import {
    SP_EVENT_BANNER_CLICK,
    SP_EVENT_BANNER_IMPRESSION
} from '@common/Tracking';
import { pushEventToDataLayer } from '@helpers/dataLayer';

const formatBannerData = (data) => {
    const {
        trackingGaBannerId = null,
        trackingId,
        trackingCreative = '',
        trackingName = '',
        trackingPosition = '',
        trackingRevisionId = '',
        trackingPageId = '',
        trackingImageSrc = ''
    } = data;

    const trackingBannerId = trackingGaBannerId ?? trackingId.split?.('~')[1] ?? trackingId;

    return {
        banner_id: trackingBannerId,
        position: trackingPosition,
        promo_id: trackingId,
        creative: trackingCreative,
        image_src: trackingImageSrc,
        page_id: trackingPageId,
        revision_id: trackingRevisionId,
        name: trackingName
    };
};

const createBannerArray = (data) => {
    const banners = [];

    if (Array.isArray(data)) {
        data.forEach((banner) => {
            banners.push(formatBannerData(banner));
        });
    } else {
        banners.push(formatBannerData(data));
    }

    return banners;
};

export const trackBannerSnowplow = (type, data) => {
    const banners = createBannerArray(data);

    if (type === 'click') {
        const eventData = {
            banners_click: banners[0]
        };

        pushEventToDataLayer(SP_EVENT_BANNER_CLICK, null, eventData);
    } else {
        const eventData = {
            banners
        };

        pushEventToDataLayer(SP_EVENT_BANNER_IMPRESSION, null, eventData);
    }
};
